import {
  errorMessageNotEmptyParameter,
  errorMessageNotValideParameter,
  errorMessageParameterUsed,
  errorMessageParameterValueUsed,
} from './MatrixParamBuild.consts'

export function getParameterErrorMessage(isDuplicate: boolean, value?: string | null) {
  const isValueValid = value != null ? /^[a-zA-Z0-9._*\-]+$/.test(value) : false

  if (value && !isValueValid) {
    return errorMessageNotValideParameter
  } else if (!value) {
    return errorMessageNotEmptyParameter
  } else if (isDuplicate) {
    return errorMessageParameterUsed
  }

  return null
}

export function getParameterValueErrorMessage(value: string | null, isDuplicate: boolean) {
  if (isDuplicate) {
    return errorMessageParameterValueUsed
  }

  return null
}
